import { h } from "preact";

import { getRandomString } from "../../../foundation/utils/string";

import IconProps from "./IconProps";

function IconTeams({
    class: cssClass,
    color
}: IconProps) {
    const getFillColor = (defaultColor: string) => color ?? `var(--icon-color, ${defaultColor})`;
    const pathId = `IconTeams-${getRandomString()}`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path fill={getFillColor("#5059C9")} d="M11.131 6.201h4.072a.7.7 0 0 1 .696.705v3.75c0 1.43-1.146 2.59-2.56 2.59h-.012c-1.413 0-2.56-1.16-2.56-2.59V6.57c0-.203.163-.368.364-.368zM13.937 5.497a1.66 1.66 0 1 0 0-3.321 1.66 1.66 0 0 0 0 3.32z"/>
                <path fill={getFillColor("#7B83EB")} d="M8.755 5.497a2.415 2.415 0 1 0 0-4.83 2.415 2.415 0 0 0 0 4.83zM11.899 6.201H5.107a.696.696 0 0 0-.68.712v4.273a4.177 4.177 0 0 0 4.075 4.273 4.177 4.177 0 0 0 4.075-4.273V6.913a.696.696 0 0 0-.68-.712z"/>
                <path fill="#000" opacity=".1" d="M8.956 6.201v5.967a.68.68 0 0 1-.675.675H4.853a4.494 4.494 0 0 1-.325-1.675V6.91a.693.693 0 0 1 .676-.709h3.752z"/>
                <path fill="#000" opacity=".2" d="M8.553 6.201v6.366a.665.665 0 0 1-.05.256.674.674 0 0 1-.62.422h-2.86a3.712 3.712 0 0 1-.3-.742 4.57 4.57 0 0 1-.194-1.312V6.913a.692.692 0 0 1 .67-.712h3.354z"/>
                <path fill="#000" opacity=".2" d="M8.553 6.201v5.568a.676.676 0 0 1-.67.671h-3.16a4.482 4.482 0 0 1-.194-1.299V6.906a.688.688 0 0 1 .67-.705h3.354z"/>
                <path fill="#000" opacity=".2" d="M8.15 6.201v5.568a.682.682 0 0 1-.68.671H4.625a4.41 4.41 0 0 1-.197-1.299V6.906a.693.693 0 0 1 .681-.705h3.042z"/>
                <path fill="#000" opacity=".1" d="M8.956 4.348V5.49c-.063.003-.122.007-.184.007-.063 0-.122-.004-.185-.007a2.058 2.058 0 0 1-.369-.058 2.386 2.386 0 0 1-1.66-1.384 1.987 1.987 0 0 1-.118-.362h1.84a.672.672 0 0 1 .676.662z"/>
                <path fill="#000" opacity=".2" d="M8.553 4.681v.816a2.404 2.404 0 0 1-2.013-1.51h1.344c.37.002.668.312.67.694z"/>
                <path fill="#000" opacity=".2" d="M8.553 4.681v.816a2.404 2.404 0 0 1-2.013-1.51h1.344c.37.002.668.312.67.694z"/>
                <path fill="#000" opacity=".2" d="M8.252 4.662v.734A2.452 2.452 0 0 1 6.54 3.987h1.015a.688.688 0 0 1 .696.675z"/>
                <path fill={`url(#${pathId})`} d="M.68 3.987h6.792a.68.68 0 0 1 .679.68v6.792a.68.68 0 0 1-.68.68H.68a.68.68 0 0 1-.679-.68V4.666a.68.68 0 0 1 .68-.679z"/>
                <path fill="#fff" d="M5.836 6.518H4.5v3.708h-.853V6.518H2.314v-.72h3.522v.72z"/>
            </g>
            <defs>
                <linearGradient id={pathId} x1="1.416" y1="3.457" x2="6.735" y2="12.669" gradientUnits="userSpaceOnUse">
                    <stop stop-color={getFillColor("#5A62C3")}/>
                    <stop offset=".5" stop-color={getFillColor("#4D55BD")}/>
                    <stop offset="1" stop-color={getFillColor("#3940AB")}/>
                </linearGradient>
            </defs>
        </svg>
    );
}

export default IconTeams;
